import axiosInstance from '../axiosInstance'

export const packageTypeService = {
    create: async (obj) => {
        try {
            let response = await axiosInstance.post('/package-type', obj)
            return response.data
        } catch (error) {
            throw error
        }
    },
    fetch: async (searchValue, client_id, query = '') => {
        try {
            let api_query = `/package-type?`
            if (client_id) {
                api_query += `$or[0][client_id]=${client_id}&$or[1][client_id][$exists]=false`;
            } else {
                api_query += `client_id[$exists]=false`;
            }

            // Add search value
            if (searchValue) api_query += `&type[$search]=${searchValue}`
            if (query.length) api_query += `&${query}`
            const response = await axiosInstance.get(`${api_query}&$sort[createdAt]=-1`)
            return response.data
        } catch (error) {
            throw error
        }
    },
    edit: async (id, obj) => {
        try {
            let response = await axiosInstance.patch(`/package-type/${id}`, obj)
            return response.data
        } catch (error) {
            throw error
        }
    },
    delete: async (id) => {
        try {
            let response = await axiosInstance.delete(`/package-type/${id}`)
            return response.data
        } catch (error) {
            throw error
        }
    }
}
